<template>
  <SlotContainer
    refName="slot-validation-box"
    slotName="validation-box"
    wrapperClass="webcomponent-validation-box"
  >
    <slot slot="validation-box" name="validation-box" />
  </SlotContainer>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';

export default ComponentInitializeDispatcher.extend({
  name: 'owc-validation-box-wrapper',
  components: {
    SlotContainer,
  },
});
</script>
